import { Model } from 'modules/core/lib/mobx-rest'

interface ISupplementValidation {
  [key: string]: any
}

class SupplementValidation extends Model<ISupplementValidation> {
  static urlRoot() {
    return '/payroll/supplement_validations'
  }
}

export default SupplementValidation
